import React from 'react';
import Select from 'react-select';

const ClassAgeGroupModal = ({ isOpen, setIsOpen }) => {
    if (!isOpen) return null;

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Class age group</h2>
                <form className="oms-modal-form">
                    <div className="oms-form-group">
                        <label htmlFor="min-age" className="oms-form-label">
                            Minimum Age
                        </label>
                        <input type="number" id="min-age" placeholder="Enter minimum age" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="max-age" className="oms-form-label">
                            Maximum Age
                        </label>
                        <input type="number" id="max-age" placeholder="Enter maximum age" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions} placeholder="Select status" />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ClassAgeGroupModal;
